import CandidateReview from "./CandidateReview";

export default CandidateReview;
